module.exports = __webpack_public_path__ + "assets/img/logo_skrill.e522b40c.svg";